import React from 'react';
import { graphql, navigate } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import styled from 'styled-components';
import { fontSize, fontWeights, standardColours } from '../styles';
import { Link, Svg } from './ui';
import { buildUrl } from '../utils';
import arrowIcon from '../images/arrow-icon.inline.svg';

const StyledMegaMenuCta = styled.article`
  cursor: pointer;
  background-color: ${standardColours.white};
  border-radius: 15px;
  overflow: hidden;
`;

const StyledInner = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  align-items: center;
`;

const StyledHeading = styled.h3`
  font-weight: ${fontWeights.regular};
  ${fontSize(20)};
  padding: 30px 20px;
  text-align: left;
`;

const StyledImageWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

const StyledImage = styled(GatsbyImage)`
  width: 100%;
  object-fit: cover;
`;

const MegaMenuCta = ({ image, heading, slug, ...props }) =>
  image && (
    <StyledMegaMenuCta onClick={() => navigate(buildUrl(slug))} {...props}>
      <StyledInner>
        <StyledHeading>
          <Link to={slug}>{heading}</Link>
        </StyledHeading>
        <StyledImageWrapper>
          <StyledImage image={image.gatsbyImageData} alt={image.alt} />
        </StyledImageWrapper>
      </StyledInner>
    </StyledMegaMenuCta>
  );

export default MegaMenuCta;

export const MegaMenuCtaFragment = graphql`
  fragment MegaMenuCtaFragment on Node {
    ... on DatoCmsPage {
      heading: title
      slug
      image: featuredImage {
        alt
        gatsbyImageData(width: 225, height: 150)
      }
      ...LinkFragment
    }
    ... on DatoCmsProductCategory {
      heading: title
      slug: shopifyCollection
      image: featuredImage {
        alt
        gatsbyImageData(width: 225, height: 150)
      }
    }
  }
`;
